import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AlertInfo } from '../../../../models/alert-info';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';
import { AlertNotificationService } from '../../../../services/alert-notification.service';
import { ProposalsService } from '../../../../services/api/proposals.service';
import { FormService } from '../../../../services/form.service';
import { ValidatorService } from '../../../../services/validator.service';
import { ProposalsAttachmentsPanelComponent } from '../proposals-attachments-panel/proposals-attachments-panel.component';
import { CustomerService } from 'src/app/services/api/customer.service';

@Component({
  selector: 'proposals-other',
  imports: [ReactiveFormsModule,ProposalsAttachmentsPanelComponent],
  templateUrl: './proposals-other.component.html',
  styleUrl: './proposals-other.component.scss'
})
export class ProposalsOtherComponent {
 @Input() proposal?: any;
  @Input() readonlyProposalsForm: boolean = false;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();

  form!: FormGroup;
  otherAgreements: any[] = [];
  private lastCustomerId?: number;
  
  alertInfo: AlertInfo = { show: false, type: '', message: '' };

  constructor(
    private validatorService: ValidatorService,
    private formService: FormService,
    private alertNotificationService: AlertNotificationService,
    private proposalsService: ProposalsService,
    private customerService: CustomerService
  ) { }
  ngOnInit(): void {
    this.form = new FormGroup({
      notes: new FormControl('', [Validators.required]),
      notesForClient: new FormControl('', [Validators.required]),
    });

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['proposal'] && changes['proposal'].currentValue) {
      this.form.patchValue({
        notes: this.proposal?.dataNotes?.content,
        notesForClient: this.proposal?.dataNotes?.content,
      });

      this.loadOtherAgreements();
    }
  }

  private loadOtherAgreements(): void {
    const customerId = this.getCustomerIdFromProposal();
    if (!customerId || customerId === this.lastCustomerId) {
      return;
    }

    this.lastCustomerId = customerId;
    this.otherAgreements = [];

    this.customerService.listOtherAgreements(customerId).subscribe({
      next: (response: any) => {
        this.otherAgreements = response?.data?.attachments ?? [];
      },
      error: (error: any) => {
        console.error('Error loading other agreements:', error);
        this.alertNotificationService.error('Error loading other agreements');
        this.showAlertInfo('danger', 'Error loading other agreements');
      }
    });
  }

  private getCustomerIdFromProposal(): number | undefined {
    return this.proposal?.request?.customer?.customerId
      ?? this.proposal?.request?.customer?.id
      ?? this.proposal?.customer?.customerId
      ?? this.proposal?.customer?.id
      ?? this.proposal?.customerId;
  }

  /**
     * *******************
     * Submit form methods
     * *******************
     */
  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.form);
    this.formService.setValidationErrors(this.form, validationErrors);
  }
  submitFormSuccess(response: any) {
    this.onSavedData.emit({
      success: true,
      response
    });
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  submitForm(): void {

    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });

    if (this.form.valid) {

      const values = Object.assign(
        this.form.value,
        {
          tenantId: 1,
        },
      )

      this.alertInfo.show = false;
      this.formService.resetErrors(this.form);

      const serviceMethod = this.proposal ? this.proposalsService.update(this.proposal.id, values) : this.proposalsService.create(values);
      serviceMethod.subscribe({
        next: (response: any) => {
          this.submitFormSuccess(response)
        },
        error: (error: any) => {
          this.submitFormError(error)
        }
      })
    }
  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */
 
}
